var map = {
	"./HTML5.svg": 1344,
	"./angularjs.svg": 1345,
	"./app-engine.svg": 1346,
	"./apple.svg": 1347,
	"./bootstrap.svg": 1348,
	"./bottle.svg": 1349,
	"./cordova.svg": 1350,
	"./csharp.svg": 1351,
	"./django.svg": 1352,
	"./dotnet.svg": 1353,
	"./electron.svg": 1354,
	"./elixir.svg": 1355,
	"./ember.svg": 1356,
	"./flask.svg": 1357,
	"./generic.svg": 1358,
	"./go.svg": 1359,
	"./ios.svg": 1360,
	"./java.svg": 1361,
	"./javascript.svg": 1362,
	"./laravel.svg": 1363,
	"./nodejs.svg": 1364,
	"./perl.svg": 1365,
	"./php.svg": 1366,
	"./python.svg": 1367,
	"./rails.svg": 1368,
	"./react.svg": 1369,
	"./redis.svg": 1370,
	"./redux.svg": 1371,
	"./ruby.svg": 1372,
	"./rust.svg": 1373,
	"./swift.svg": 1374,
	"./vue.svg": 1375,
	"./windows.svg": 1376
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1343;